export default __webpack_public_path__ + "static/media/userprofile.99004753.svg";